<template>
  <header class="sticky-header">
    <header-top-vue />
    <header-bottom-vue
      :additional="additional"
      :heading="heading"
      :specific-link="'CHAT'"
      :back-button="backButton"
    />
    <div>
      <list :show="show" :update-show="updateShow" />
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import HeaderBottomVue from "../../common/HeaderBottom";
import HeaderTopVue from "../../common/HeaderTop.vue";
import List from "./List";

export default {
  props: {
    addNew: Boolean,
    hideNew: Function,
    additional: Object,
    show: String, // Show which inner
    updateShow: Function // Update which inner to show
  },
  computed: {
    ...mapGetters("favourites", {
      favouriteMode: "getFavouriteMode"
    }),
    heading() {
      if (this.addNew) {
        return "Add Chat";
      } else if (this.favouriteMode) {
        return "Chat Favorites";
      } else {
        return "Recent Chats";
      }
    },
    backButton() {
      return { show: this.addNew, action: this.hideNew };
    }
  },
  components: {
    HeaderTopVue,
    HeaderBottomVue,
    List
  }
};
</script>

<style scoped>
header >>> .year-wrapper {
  position: absolute;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  line-height: 18px;
}

@media (max-width: 450px) {
  header >>> .year-wrapper span {
    font-size: 18px !important;
  }
}
</style>
